import { $, $$ } from '../../../shared/js/utils/dom';

const randomFigures = $$('.random-figure');

randomFigures.forEach(randomFigure => {
  const figures = $$('figure', randomFigure);
  const randomIndex = Math.floor(Math.random() * figures.length);

  figures.forEach((figure, index) => {
    if (index === randomIndex) {
      const img = $('img', figure);
      const sources = $$('source', figure);

      sources.forEach(source => {
        source.setAttribute('srcset', source.dataset.srcset);
      });
      img.setAttribute('src', img.dataset.src);
      figure.classList.add('random-figure__result');
    }
  });
});
